import {
  faAdd,
  faCheckCircle,
  faClone,
  faDollarSign,
  faEdit,
  faExclamationCircle,
  faMoneyBillWheat,
  faSearch,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { format } from 'date-fns'
import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'
import { Check2Square } from 'react-bootstrap-icons'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { Ask } from '../../components/Ask'
import AutocompleteClienteNode from '../../components/autocomplete-cliente/autocomplete-clientenode'
import { CustomButton } from '../../components/CustomButton'
import Navbar from '../../components/navbar/navbar'
import { useOrdenation } from '../../hooks/useOrdenation'
import apinode from '../../services/apinode'
import { getValue } from '../../utils/getValue'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import './ContasApagar.css'

function AccountTable() {
  const [contas, setContas] = useState([])
  const [selectedAccounts, setSelectedAccounts] = useState([])
  const [filteredContas, setFilteredContas] = useState([])
  const [searchTextApi, setSearchTextApi] = useState('')
  const conta = localStorage.idconta
  const [editedConta, setEditedConta] = useState(conta)
  const [showModal, setShowModal] = useState(false)
  const [nomeCliente, setNomeCliente] = useState('')
  const [_, setIdCliente] = useState('')
  const [__, setCpfCliente] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [selectedSituacao, setSelectedSituacao] = useState('')
  const [categoryDescriptions, setCategory] = useState('')
  const [selectedDescription, setSelectedDescription] = useState('')
  const [isCloneAccountLoading, setIsCloneAccountLoading] = useState({})
  const [isDeleteAccountLoading, setIsDeleteAccountLoading] = useState({})
  const [isSearchingAccount, setIsSearchingAccount] = useState(false)

  const navigate = useNavigate()
  const situacoes = ['Em Aberto', 'Pago', 'Vencida']

  // Função para converter a data ISO "2023-07-04T03:00:00.000Z" para "yyyy-MM-dd"
  function convertISOToYMD(isoDateString) {
    const isoDate = new Date(isoDateString)
    const year = isoDate.getUTCFullYear()
    const month = String(isoDate.getUTCMonth() + 1).padStart(2, '0')
    const day = String(isoDate.getUTCDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  async function fetchCategoryDescriptions() {
    try {
      const response = await apinode.get(
        `/contas/categoria/${localStorage.idconta}`,
      )
      const data = await response.data
      setCategory(response.data)

      return data
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar as categorias')
    }
  }

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value)
  }

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value)
  }

  async function handleClone(accountId, index) {
    try {
      setIsCloneAccountLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await apinode.get(`/contas/clonar/${accountId}/${localStorage.idconta}`)

      toast.success('Conta clonada com sucesso')

      await listarContas()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao clonar conta')
    } finally {
      setIsCloneAccountLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  const handleSituacaoChange = (event) => {
    setSelectedSituacao(event.target.value)
  }

  const formatCurrency = (value) => {
    return value
      ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      : ''
  }

  const handleNomeCliente = (nome) => {
    setNomeCliente(nome)
    // Atualize o campo PES_RAZAO em editedConta com o nome do cliente selecionado
    setEditedConta((prevEditedConta) => ({
      ...prevEditedConta,
      PES_RAZAO: nome,
    }))
  }

  // Filtrar as contas com base na situação selecionada
  const filterContas = contas.filter(
    (account) =>
      selectedSituacao === '' || account.SITUACAO === selectedSituacao,
  )

  function convertDateToISO(dateString) {
    const [day, month, year] = dateString.split('/')
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }

  const handleIdCliente = (id) => {
    setIdCliente(id)
    setEditedConta((prevEditedConta) => ({
      ...prevEditedConta,
      ID_FORNECEDOR: id,
    }))
    // Faça outras ações necessárias ao selecionar o cliente pelo ID
  }

  const handleCpf = (cpf) => {
    setCpfCliente(cpf)
    // setEditedConta((prevEditedConta) => ({
    //   ...prevEditedConta,
    //   ID_FORNECEDOR: id,
    // }));
    // Faça outras ações necessárias ao selecionar o cliente pelo CPF
  }

  // Função de comparação para ordenar as contas por data de vencimento
  const compareByVencimento = (a, b) => {
    const dateA = new Date(a.VENCIMENTO)
    const dateB = new Date(b.VENCIMENTO)
    return dateA - dateB // Ordenação ascendente, para ordenação descendente use dateB - dateA
  }

  async function handleBaixarContas() {
    const { value: date } = await Swal.fire({
      title: 'Selecione uma data',
      input: 'date',
      confirmButtonText: 'Confirmar',
      confirmButtonColor: '#007bff',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      icon: 'warning',
      didOpen: () => {
        Swal.getInput().value = format(new Date(), 'yyyy-MM-dd')
      },
    })

    if (date) {
      try {
        await apinode.put(`/contas/pgconta/${conta}`, {
          ids: selectedAccounts,
          date,
        })

        await listarContas()

        toast.success('Conta(s) baixada(s) com sucesso')
      } catch (err) {
        sendErrorApiMessage(err, 'Erro ao baixar contas')
      }
    }
  }

  function handleInputChangeEdit(event) {
    const { name, value } = event.target

    // Verificar se o campo é o campo de data (por exemplo, "VENCIMENTO")
    // Se for o campo de data, converter o valor para o formato ISO "yyyy-MM-dd"
    if (name === 'VENCIMENTO') {
      const isoDate = convertDateToISO(value)
      setEditedConta({ ...editedConta, [name]: isoDate })
    } else {
      setEditedConta({ ...editedConta, [name]: value })
    }
  }

  const handleSalvarEdicao = () => {
    setShowModal(false)
  }

  function handleInputChangeEdit(event) {
    const { name, value } = event.target

    if (name === 'VENCIMENTO') {
      if (value) {
        const isoDate = convertISOToYMD(value)
        setEditedConta({ ...editedConta, [name]: isoDate })
      } else {
        setEditedConta({ ...editedConta, [name]: '' })
      }
    } else {
      setEditedConta({ ...editedConta, [name]: value })
    }
  }

  const listarContas = useCallback(async () => {
    try {
      const response = await apinode.get('/contas/busca', {
        params: {
          conta: localStorage.idconta,
        },
      })

      const sortedContas = response.data.sort(compareByVencimento)
      setContas(sortedContas)
      setFilteredContas(sortedContas)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao listar contas')
    }
  }, [])

  const handleEdit = (account) => {
    navigate(`/contasapagar/editar/${account}`)
  }

  async function handleDelete(account, index) {
    try {
      setIsDeleteAccountLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await apinode.delete(`/contas/deletar/${conta}/${account}`)

      toast.success('Conta excluída com sucesso')

      await listarContas()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao deletar conta a pagar')
    } finally {
      setIsDeleteAccountLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  function selectAll(items) {
    for (const item of items) {
      setSelectedAccounts((prevState) => {
        if (!prevState.includes(item.ID)) {
          return [...prevState, item.ID]
        }

        return prevState
      })
    }
  }

  const filteredAccounts = useMemo(() => {
    let data = filteredContas

    if (selectedSituacao) {
      data = data.filter((account) => {
        switch (selectedSituacao) {
          case 'Em Aberto': {
            return new Date(account.VENCIMENTO) >= new Date()
          }

          case 'Pago': {
            return account.SITUACAO === 'Pago'
          }

          case 'Vencida': {
            return (
              new Date(account.VENCIMENTO) < new Date() &&
              account.SITUACAO !== 'Pago'
            )
          }
        }
      })
    }

    if (selectedDescription) {
      data = data.filter((account) => account.CATEGORIA === selectedDescription)
    }

    return data
  }, [filteredContas, selectedDescription, selectedSituacao])

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(filteredAccounts, 'VENCIMENTO', 'asc', '25')

  function removeAll(items) {
    for (const item of items) {
      setSelectedAccounts((prevState) =>
        prevState.filter((accountId) => accountId !== item.ID),
      )
    }
  }

  const handleSearchContas = async () => {
    let data1 = ''
    let data2 = ''

    if (startDate.trim() !== '') {
      data1 = startDate
    }

    if (endDate.trim() !== '') {
      data2 = endDate
    }

    try {
      setIsSearchingAccount(true)

      const response = await apinode.get(
        `/contas/search/${conta}?data1=${data1}&data2=${data2}&searchTerm=${searchTextApi}`,
      )

      const sortedContas = response.data.sort(compareByVencimento)
      setContas(sortedContas)
      setFilteredContas(sortedContas)

      sortContasByVencimento()
    } catch (err) {
      console.error('Ops! Ocorreu um erro' + err)
    } finally {
      setIsSearchingAccount(false)
    }
  }

  function sortContasByVencimento() {
    const sortedContas = [...contas].sort((a, b) => {
      return new Date(a.VENCIMENTO) - new Date(b.VENCIMENTO)
    })

    setContas(sortedContas)
  }

  const totalContas = contas.length

  const vencendoHoje = contas.filter(
    (conta) => new Date(conta.VENCIMENTO) === new Date(),
  ).length

  const contasVencidas = contas.filter(
    (conta) =>
      new Date(conta.VENCIMENTO) < new Date() && conta.SITUACAO !== 'Pago',
  ).length

  const contasAVencer = contas.filter(
    (conta) => new Date(conta.VENCIMENTO) >= new Date(),
  ).length

  const contasPagas = contas.filter((conta) => conta.SITUACAO === 'Pago').length

  const somaContasSelecionadas = selectedAccounts.reduce((total, accountId) => {
    const conta = contas.find((item) => item.ID === accountId)

    return total + (conta ? conta.VALOR : 0)
  }, 0)

  // const categorySums = {}
  // filterContas.forEach((account) => {
  //   const categoria = account.CATEGORIA // Replace with your actual field name
  //   const valor = account.VALOR || 0 // Replace with your actual field name
  //   if (!categorySums[categoria]) {
  //     categorySums[categoria] = {
  //       description: categoria, // Use the category code as the default description
  //       sum: 0,
  //     }
  //   }
  //   categorySums[categoria].sum += valor
  // })
  const categorySums = {}
  filteredAccounts.forEach((account) => {  // Usar filteredAccounts em vez de filterContas
    const categoria = account.CATEGORIA
    const valor = account.VALOR || 0
    if (!categorySums[categoria]) {
      categorySums[categoria] = {
        description: categoria,
        sum: 0,
      }
    }
    categorySums[categoria].sum += valor
  })

  const handleInputChange = (e) => {
    setSearchTextApi(e.target.value)
  }

  const getDescriptionByCode = (code) => {
    try {
      const numericCode = parseInt(code) // Converte para número, se for uma string
      const category = categoryDescriptions.find(
        (category) => category.CODIGO === numericCode,
      )
      if (category) {
        return <Badge bg="primary">{category.DESCRICAO}</Badge>
      }
    } catch (error) {
      console.error('Erro ao obter descrição:', error)
      return 'Descrição Desconhecida'
    }
  }

  useEffect(() => {
    fetchCategoryDescriptions()
    listarContas()
  }, [listarContas])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <Col>
          <h1 className="text-start custom-header">Contas a Pagar</h1>
        </Col>

        <div className="container-p3 mb-2">
          <Row>
            <Col>
              <label
                htmlFor="searchInput"
                className="visually-hidden"
              >
                Pesquisar contas
              </label>

              <input
                type="text"
                id="searchInput"
                className="form-control  me-4"
                placeholder="Pesquisar contas..."
                value={searchTextApi}
                onChange={handleInputChange}
                onKeyDown={(e) => {
                  if (searchTextApi) {
                    if (e.key === 'Enter') {
                      handleSearchContas()
                    }
                  }
                }}
              />
            </Col>

            <Col>
              <CustomButton
                isSuccess
                onClick={handleSearchContas}
                title="Pesquisar"
                isLoadingText="Pesquisando..."
                isLoading={isSearchingAccount}
              >
                <FontAwesomeIcon
                  icon={faSearch}
                  className="me-2"
                />
              </CustomButton>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col xs={2}>
              <label
                htmlFor="startDateInput"
                className="visually-hidden"
              >
                Data de início
              </label>
              <input
                type="date"
                id="startDateInput"
                className="form-control me-2" // Add "me-2" class for right margin
                value={startDate}
                onChange={handleStartDateChange}
              />
            </Col>

            <Col xs={2}>
              {/* Data de término */}
              <label
                htmlFor="endDateInput"
                className="visually-hidden"
              >
                Data de término
              </label>
              <input
                type="date"
                id="endDateInput"
                className="form-control me-2" // No additional class for the second input
                value={endDate}
                onChange={handleEndDateChange}
              />
            </Col>

            <Col>
              <div
                style={{
                  display: 'flex',
                  gap: 10,
                }}
              >
                <button className="btn btn-primary btn-sm">
                  <FontAwesomeIcon
                    icon={faAdd}
                    className="me-2"
                  />

                  <Link
                    className="text-white text-decoration-none"
                    to="/contasapagar/novo"
                  >
                    Add Conta
                  </Link>
                </button>

                <button
                  className="btn btn-primary btn-sm"
                  onClick={handleBaixarContas}
                  disabled={selectedAccounts.length === 0}
                >
                  <FontAwesomeIcon
                    icon={faMoneyBillWheat}
                    className="me-2"
                  />
                  Baixar Selec.
                </button>

                {/* <button
                  className="btn btn-primary btn-sm"
                  onClick={handleSearchContas}
                >
                  <FontAwesomeIcon
                    icon={faPrint}
                    className="me-2"
                  />
                  Imprimir
                </button> */}
              </div>
            </Col>
          </Row>
        </div>

        <div className="container-p3">
          <Card>
            <Card.Body>
              <div className="row">
                <div className="col">
                  <Card>
                    <Card.Body>
                      <div className="d-flex justify-content-between">
                        <div>
                          <h3>Resumo das Contas</h3>
                          <p>Total de contas: {totalContas}</p>
                          <p className="text-danger">
                            <span class="badge bg-danger">
                              Vencidas: {contasVencidas}
                            </span>
                          </p>
                          <p>
                            <span class="badge bg-warning">
                              {' '}
                              Aberto: {contasAVencer}
                            </span>
                          </p>
                          <p className="text-success">
                            <span class="badge bg-success">
                              {' '}
                              Pagas: {contasPagas}
                            </span>
                          </p>
                          <p className="text-success">
                            <span class="badge bg-primary">
                              {' '}
                              Vencendo: {vencendoHoje}
                            </span>
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>

                <div className="col">
                  <Card>
                    <Card.Body>
                      <h4>Resumo por Categoria</h4>
                      {Object.values(categorySums).map(
                        ({ description, sum }) => (
                          <p
                            key={description}
                            onClick={() => {
                              console.log('Descrição clicada:', description)
                              setSelectedDescription(description)
                              //  setFilteredContas(contas)
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            {getDescriptionByCode(description)}{' '}
                            <Badge bg="secondary">
                              {sum.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </Badge>
                          </p>
                        ),
                      )}
                    </Card.Body>
                  </Card>
                </div>
                <div className="col">
                  <Card>
                    <Card.Body>
                      <h4>Selecione a situação</h4>
                      <select
                        className="form-control"
                        value={selectedSituacao}
                        onChange={handleSituacaoChange}
                      >
                        <option value="">Selecione uma opção</option>
                        {situacoes.map((situacao, index) => (
                          <option
                            key={index}
                            value={situacao}
                          >
                            {situacao}
                          </option>
                        ))}
                      </select>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>

        <Card>
          <Card.Body>
            <p className="text-success">
              {somaContasSelecionadas > 0 && (
                <span className="badge bg-secondary">
                  Soma selecionadas:{' '}
                  {somaContasSelecionadas.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </span>
              )}
            </p>

            <Table
              striped
              bordered
              hover
              responsive
              className="nowrap"
            >
              <thead>
                <tr>
                  <th
                    scope="row"
                    colspan="10"
                  >
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <CustomButton
                        noMargin
                        title="Selecionar/Desmarcar Todos"
                        onClick={() => {
                          if (selectedAccounts.length > 0) {
                            setSelectedAccounts([])
                          } else {
                            selectAll(filteredAccounts)
                          }
                        }}
                      >
                        <Check2Square />
                      </CustomButton>
                      <strong>{selectedAccounts.length} selecionados</strong>

                      <strong>
                        Mostrando {filteredItems.length} de{' '}
                        {filteredAccounts.length}
                      </strong>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <Form.Label>Contas p/ pág.</Form.Label>
                        <Form.Select
                          value={itemsPerPage}
                          onChange={(e) => setItemsPerPage(e.target.value)}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </Form.Select>
                      </div>
                    </div>
                  </th>
                </tr>

                <tr>
                  <th style={{ width: '1px' }}>
                    <Form.Check
                      checked={
                        selectedAccounts.length > 0 &&
                        filteredItems.every((account) =>
                          selectedAccounts.includes(account.ID),
                        )
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          selectAll(filteredItems)
                        } else {
                          removeAll(filteredItems)
                        }
                      }}
                    />
                  </th>
                  <Th
                    label="ID"
                    value="ID"
                  />
                  <Th
                    label="Situação"
                    value="SITUACAO"
                  />

                  <Th
                    label="Fornecedor"
                    value="PES_RAZAO"
                  />

                  <Th
                    label="Descrição"
                    value="HISTORICO_CONTA"
                  />

                  <Th
                    label="Vencimento"
                    value="VENCIMENTO"
                  />

                  <Th
                    label="Valor"
                    value="VALOR"
                  />

                  <Th
                    label="Grupo Despesa"
                    value="TIPO_DESPESA"
                  />

                  <th className="text-dark">Ações</th>
                </tr>
              </thead>

              <tbody>
                {filteredItems.map((account, index) => (
                  <tr
                    key={account.ID}
                    className={account.id % 2 === 0 ? 'even' : 'odd'}
                  >
                    <td>
                      <Form.Check
                        checked={selectedAccounts.includes(account.ID)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedAccounts((prevState) => [
                              ...prevState,
                              account.ID,
                            ])
                          } else {
                            setSelectedAccounts((prevState) =>
                              prevState.filter(
                                (accountId) => accountId !== account.ID,
                              ),
                            )
                          }
                        }}
                      />
                    </td>
                    <td>{account.ID}</td>

                    <td style={{ fontSize: '12px' }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                      >
                        {account.SITUACAO === 'Pago' ? (
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            color="#0d6efd"
                            style={{
                              width: 20,
                              height: 20,
                            }}
                          />
                        ) : account.VENCIMENTO < new Date().toISOString() ? (
                          <FontAwesomeIcon
                            icon={faExclamationCircle}
                            color="#0d6efd"
                            style={{
                              width: 20,
                              height: 20,
                            }}
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faDollarSign}
                            color="#0d6efd"
                            style={{
                              width: 20,
                              height: 20,
                            }}
                          />
                        )}

                        {account.SITUACAO}
                      </div>
                    </td>
                    <td style={{ fontSize: '12px' }}>
                      {account.ID_FORNCEDOR} - {account.PES_RAZAO}
                    </td>

                    <td style={{ fontSize: '12px' }}>
                      {account.HISTORICO_CONTA}
                    </td>
                    <td style={{ fontSize: '12px' }}>
                      {getValue(
                        account?.VENCIMENTO &&
                        new Date(account.VENCIMENTO).toLocaleDateString(),
                      )}
                    </td>
                    <td style={{ fontSize: '12px' }}>
                      {account.VALOR?.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }) || ''}
                    </td>
                    <td style={{ fontSize: '12px' }}>
                      {account?.TIPO_DESPESA}
                    </td>
                    <td>
                      <div className="d-flex">
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                          <button
                            className="btn btn-warning me-2 btn-sm"
                            onClick={() => handleEdit(account.ID)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                          <CustomButton
                            isDelete
                            isLoading={isDeleteAccountLoading[index]}
                            onClick={() =>
                              Ask('Tem certeza que deseja excluir?', () =>
                                handleDelete(account.ID, index),
                              )
                            }
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </CustomButton>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Clonar</Tooltip>}>
                          <CustomButton
                            isLoading={isCloneAccountLoading[index]}
                            onClick={() =>
                              Ask('Tem certeza que deseja clonar?', () =>
                                handleClone(account.ID, index),
                              )
                            }
                          >
                            <FontAwesomeIcon icon={faClone} />
                          </CustomButton>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </Card.Body>
        </Card>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-1 col-md-8">
          <div className="input-group mb-3"></div>
        </div>

        {/* Modal de Edição */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Editar Conta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="col-md-12 mb-3">
                <label
                  htmlFor="CLIENTE"
                  className="form-label"
                >
                  Cliente:
                </label>
                <AutocompleteClienteNode
                  placeholder="Pesquisar cliente..."
                  onClickNome={handleNomeCliente}
                  onClickId={handleIdCliente}
                  onClickCpf={handleCpf}
                  value={nomeCliente} // Passa o nome do cliente selecionado ao componente
                  className="form-control"
                />
              </div>

              <div className="row mb-3">
                <div className="col-md-2">
                  <label
                    htmlFor="ID"
                    className="form-label"
                  >
                    ID:
                  </label>
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    name="ID"
                    value={editedConta?.ID || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                <div className="col-md-4">
                  <label
                    htmlFor="IDPEDIDOCOMPRA"
                    className="form-label"
                  >
                    ID Pedido/ Nfe:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="IDPEDIDOCOMPRA"
                    value={editedConta?.IDPEDIDOCOMPRA || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="PES_RAZAO"
                    className="form-label"
                  >
                    Razão do Fornecedor:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="PES_RAZAO"
                    value={editedConta?.PES_RAZAO || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-3">
                  <label
                    htmlFor="ID_FORNCEDOR"
                    className="form-label"
                  >
                    ID Fornecedor:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="ID_FORNCEDOR"
                    value={editedConta?.ID_FORNCEDOR || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="PES_CNPJ_CPF"
                    className="form-label"
                  >
                    CNPJ/CPF do Fornecedor:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="PES_CNPJ_CPF"
                    value={editedConta?.PES_CNPJ_CPF || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                {/* You can continue adding more fields here */}
              </div>
              <div className="row mb-3"></div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="FORMA_DE_PGTO"
                    className="form-label"
                  >
                    Forma de Pagamento:
                  </label>
                  <select
                    className="form-select"
                    name="FORMA_DE_PGTO"
                    value={editedConta?.FORMA_DE_PGTO || ''}
                    onChange={handleInputChangeEdit}
                  >
                    <option value="">Selecione a Forma de Pagamento</option>
                    <option value="dinheiro">Dinheiro</option>
                    <option value="cartao_debito">Cartão de Débito</option>
                    <option value="cartao_credito">Cartão de Crédito</option>
                    <option value="transferencia_bancaria">
                      Transferência Bancária
                    </option>
                    <option value="Boleto">Boleto Bancário</option>
                    <option value="cheque">Cheque</option>
                    <option value="pix">PIX</option>
                    {/* Adicione mais opções conforme necessário */}
                  </select>
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="NUMERO_IDENT"
                    className="form-label"
                  >
                    Número Ident:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="NUMERO_IDENT"
                    value={editedConta?.NUMERO_IDENT || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="NUMERO_DOC"
                    className="form-label"
                  >
                    Número Doc:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="NUMERO_DOC"
                    value={editedConta?.NUMERO_DOC || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="VENCIMENTO"
                    className="form-label"
                  >
                    Vencimento:
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="VENCIMENTO"
                    value={editedConta.VENCIMENTO}
                    onChange={handleInputChangeEdit}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="VALOR"
                    className="form-label"
                  >
                    Valor:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="VALOR"
                    value={formatCurrency(editedConta?.VALOR) || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="SITUACAO"
                    className="form-label"
                  >
                    Situação:
                  </label>
                  <select
                    className="form-select"
                    name="SITUACAO"
                    value={editedConta?.SITUACAO || ''}
                    onChange={handleInputChangeEdit}
                  >
                    <option value="Em Aberto">Em Aberto</option>
                    <option value="Pago">Pago</option>
                    <option value="Aguardando Pagamento">
                      Aguardando Pagamento
                    </option>
                    <option value="Vencida">Vencida</option>
                    <option value="Cartorio">Cartorio</option>
                  </select>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="VENCIMENTO_ORIGINAL"
                    className="form-label"
                  >
                    Vencimento Original:
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="VENCIMENTO_ORIGINAL"
                    value={editedConta?.VENCIMENTO_ORIGINAL || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="DATA_EMISSAO"
                    className="form-label"
                  >
                    Data de Emissão:
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="DATA_EMISSAO"
                    value={editedConta?.DATA_EMISSAO || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="COMPETENCIA"
                    className="form-label"
                  >
                    Competência:
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="COMPETENCIA"
                    value={editedConta?.COMPETENCIA || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="PORTADOR"
                    className="form-label"
                  >
                    Portador:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="PORTADOR"
                    value={editedConta?.PORTADOR || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="CATEGORIA"
                    className="form-label"
                  >
                    Categoria:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="CATEGORIA"
                    value={editedConta?.CATEGORIA || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="OCORRENCIA"
                    className="form-label"
                  >
                    Ocorrência:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="OCORRENCIA"
                    value={editedConta?.OCORRENCIA || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
              </div>

              <div className="col-md-12">
                <label
                  htmlFor="HISTORICO_CONTA"
                  className="form-label"
                >
                  Histórico da Conta:
                </label>
                <textarea
                  className="form-control"
                  name="HISTORICO_CONTA"
                  value={editedConta?.HISTORICO_CONTA || ''}
                  onChange={handleInputChangeEdit}
                  rows={4} // Defina a altura (em número de linhas) do textarea
                />
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="DATA_PGTO"
                    className="form-label"
                  >
                    Data de Pagamento:
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="DATA_PGTO"
                    value={editedConta?.DATA_PGTO || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="SUB_CATEGORIA"
                    className="form-label"
                  >
                    Subcategoria:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="SUB_CATEGORIA"
                    value={editedConta?.SUB_CATEGORIA || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="IDNFEENTRADA"
                    className="form-label"
                  >
                    ID NFE Entrada:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="IDNFEENTRADA"
                    value={editedConta?.IDNFEENTRADA || ''}
                    onChange={handleInputChangeEdit}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Fechar
            </Button>
            <Button
              variant="warning"
              onClick={handleSalvarEdicao}
            >
              Baixar
            </Button>
            <Button
              variant="primary"
              onClick={handleSalvarEdicao}
            >
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default AccountTable
